import _ from 'lodash'

// Import only the exchange list from generated data to avoid CCXT dependency in frontend
import { ccxtExchanges } from './generated-exchange-data.js'

export { ccxtExchanges }

export type CcxtExchange = (typeof ccxtExchanges)[number]

export type CcxtExchanges = readonly CcxtExchange[]

export const exchangesByRank = {
  ccxt: [
    // exchange tiers
    ['coinbase', 'kraken', 'bitfinex', 'binanceus', 'binance', 'bitstamp', 'gemini', 'okx'],
    ['gateio', 'bitget', 'kucoin', 'huobi', 'mexc', 'gate'],
    ccxtExchanges,
  ],
  dex: [
    ['pulsexv2_xyk', 'pulsex_xyk'],
  ],
  // a non nill value to differentiate between existing and not existing
  stable: [['']],
} as const

export const exchangeNameList = [
  ...exchangesByRank.ccxt[0],
  ...exchangesByRank.ccxt[1],
  ...exchangesByRank.ccxt[2],
  ...exchangesByRank.dex[0],
  ...exchangesByRank.stable[0],
] as const

export const CCXTExchanges = [
  ...exchangesByRank.ccxt[0],
  ...exchangesByRank.ccxt[1],
  ...exchangesByRank.ccxt[2],
] as const

export const exchangesUnderSources = {
  stable: exchangesByRank.stable,
  ccxt: exchangesByRank.ccxt,
  dex: exchangesByRank.dex,
  zero: [] as const, // Explicitly ignored tokens - no pricing needed
  pending: [] as const, // Tokens pending pricing mechanism - ignored by pricing script
} as const

export const pricingSources = {
  stable: 'stable',
  ccxt: 'ccxt',
  dex: 'dex',
}

export type PricingSource = keyof typeof pricingSources
export const pricingSourcesList = Object.keys(pricingSources) as [PricingSource, ...PricingSource[]]

export type PricingExchangeSource = keyof typeof exchangesUnderSources
export const pricingExchangeSourcesList = Object.keys(exchangesUnderSources) as [PricingExchangeSource, ...PricingExchangeSource[]]

// Actual pricing sources (excludes 'zero' and 'pending' which are special cases)
export const actualPricingSources = {
  stable: 'stable',
  ccxt: 'ccxt',
  dex: 'dex',
} as const satisfies Record<string, PricingSource>

export type ExchangeName = (typeof exchangeNameList)[number]

export type CCXTExchange = (typeof CCXTExchanges)[number]

export const dexExchanges = [
  ...exchangesByRank.dex[0],
] as const

export type DexExchange = (typeof dexExchanges)[number]
